import { t } from '@framework/i18n/intl/i18next.ts';
import { Checkbox } from 'antd';

interface IShowOnlySelectedCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * Componente checkbox per il filtro "Mostra solo selezionate"
 */
export function ShowOnlySelectedCheckbox(
  props: IShowOnlySelectedCheckboxProps,
) {
  const { checked, onChange } = props;

  return (
    <Checkbox
      checked={checked}
      onChange={event => onChange(event.target.checked)}
    >
      {t(
        'widgets.advanced-select.show-only-selected',
        'Mostra solo selezionate',
      )}
    </Checkbox>
  );
}
